import api from '../../../util/api';
import { setAlert } from '../../alert';
import { getConfig, getFormDataConfig } from '../constants/00-base-constants';
import {
    API_POST_STATIONARY_OR_MOBILE_PETROL_DATA,
    API_GET_STATIONARY_OR_MOBILE_PETROL_DATA,
    API_GET_STATIONARY_OR_MOBILE_PETROL_DATA_TOTALS
} from '../constants/01-direct-ghg-emissions-and-removals-constants';
import {
    POST_STATIONARY_OR_MOBILE_PETROL_DATA_SUCCESS,
    POST_STATIONARY_OR_MOBILE_PETROL_DATA_FAIL,
    GET_STATIONARY_OR_MOBILE_PETROL_DATA_SUCCESS,
    GET_STATIONARY_OR_MOBILE_PETROL_DATA_FAIL,
    GET_STATIONARY_OR_MOBILE_PETROL_DATA_TOTALS_SUCCESS,
    GET_STATIONARY_OR_MOBILE_PETROL_DATA_TOTALS_FAIL
} from '../types/01-direct-ghg-emissions-and-removals-types';


export const postStationaryOrMobilePetrolData = (formData, type, year, company, group, facility, month) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_STATIONARY_OR_MOBILE_PETROL_DATA + `/${type}/${year}/${company}/${group}/${facility}/${month}`,
            formData,
            getFormDataConfig()
        );
        dispatch({
            type: POST_STATIONARY_OR_MOBILE_PETROL_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_STATIONARY_OR_MOBILE_PETROL_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getStationaryOrMobilePetrolData = (type, year, facility, rowsPerPage, currentPage, month) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_STATIONARY_OR_MOBILE_PETROL_DATA + `/${type}/${year}/${facility}/${rowsPerPage}/${currentPage}/${month}`,
            getConfig()
        );
        dispatch({
            type: GET_STATIONARY_OR_MOBILE_PETROL_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_STATIONARY_OR_MOBILE_PETROL_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getStationaryOrMobilePetrolDataTotals = (type, year, facility) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_STATIONARY_OR_MOBILE_PETROL_DATA_TOTALS + `/${type}/${year}/${facility}`,
            getConfig()
        );
        dispatch({
            type: GET_STATIONARY_OR_MOBILE_PETROL_DATA_TOTALS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_STATIONARY_OR_MOBILE_PETROL_DATA_TOTALS_FAIL,
            payload: err.response.data.detail,
        });
    }
};
